<div class="seg-tasks-widget">
  @if (profiles?.length) {
    @for (seg of profiles!; track trackByIndex($index)) {
      <div [style]="styles.section">
        <div [style]="styles.subHeading">{{ seg.segName }} — {{ labels.heading }}</div>
        @if (seg.taskGroups.length) {
          @for (group of seg.taskGroups; track trackByIndex($index)) {
            <div>
              @if (showGroupHeadings && group.groupName) {
                <div [style]="styles.tag">
                  <strong>{{ group.groupName }}</strong>
                </div>
              }
              <ul>
                @for (task of group.tasks; track trackByIndex($index)) {
                  <li [style]="styles.tag">{{ task }}</li>
                }
              </ul>
            </div>
          }
        } @else {
          <p [style]="styles.noData">{{ labels.noData }}</p>
        }
      </div>
    }
  } @else {
    <p [style]="styles.noData">{{ labels.noData }}</p>
  }
</div>
